export default {"src":"/planos/_next/static/media/equifax-user.408ae655.svg","height":15,"width":16,"blurWidth":0,"blurHeight":0};